import { render } from "./CollectionAvatar.vue?vue&type=template&id=50ba43f2"
import script from "./CollectionAvatar.vue?vue&type=script&lang=js"
export * from "./CollectionAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__